import * as React from 'react';

function SvgIconWarning(props) {
  return (
    <svg viewBox="0 0 56 56" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g fill="none" fillRule="evenodd">
        <circle fill="#FFF8DA" cx={28} cy={28} r={28} />
        <path
          d="M27.143 36h1.714a2 2 0 012 2v1.143a2 2 0 01-2 2h-1.714a2 2 0 01-2-2V38a2 2 0 012-2zm0-22.286h1.714a2 2 0 012 2v16.572a2 2 0 01-2 2h-1.714a2 2 0 01-2-2V15.714a2 2 0 012-2z"
          fill="#FCCE01"
        />
      </g>
    </svg>
  );
}

export default SvgIconWarning;
